export const ROWS_PER_PAGE = [50, 100, 200];
export const DEFAULT_ROWS_PER_PAGE = 50;
export const DEFAULT_PAGE = 1;
